import moment from "moment";

// Dates arrive from the API as a bare "YYYY-MM-DD". Parsing with an explicit, strict format keeps
// moment off its deprecated fallback path and off any timezone shift that could roll the day back.
// Returns null rather than the raw value so callers can render nothing instead of "Invalid date" —
// the underlying `races.date` is nullable.
export default function formatDate(value) {
  if (!value) return null;
  const parsed = moment(value, "YYYY-MM-DD", true);
  return parsed.isValid() ? parsed.format("DD.MM.YYYY") : null;
}
